import { gql } from 'apollo-boost'

const SCRAPING_SESSION_TEMPLATES = gql`
  query scrapingSessionTemplates(
    $filters: ScrapingSessionTemplateFiltersInput!
    $page: Int
    $pageSize: Int
  ) {
    scrapingSessionTemplates(
      filters: $filters
      page: $page
      pageSize: $pageSize
    ) {
      scrapingSessionTemplates {
        id
        name
        alias
        description
        scrapingTestCaseCount
        tagGroups {
          id
          name
          alias
          description
          tags {
            id
            name
            type
          }
        }
        createdBy {
          id
          name
        }
        lastModifiedBy {
          id
          name
        }
      }
      total
    }
  }
`

export default SCRAPING_SESSION_TEMPLATES
